// ============================================
// MyPage - Index Module (ES6)
// 진입점 및 통합 관리
// ============================================

// Sub-modules
export * from './carbon.js';
export * from './avatar.js';
export { getDb } from './state.js';

import { getCurrentUser } from '../app/state.js';
import { getUserNickname } from '../auth/state.js';

// Re-import for internal use
import {
  openCarbonModal, closeCarbonModal, updateCarbonDisplay,
  loadCarbonHistory, filterCarbonHistory,
  openCarbonRechargeModal, closeCarbonRechargeModal,
  selectCarbonPackage, purchaseCarbon, updateCarbonBalance,
  loadCarbonProducts, verifyGooglePurchase, verifyApplePurchase
} from './carbon.js';

import {
  openAvatarUploadModal, closeAvatarUploadModal,
  handleAvatarFileSelect, updateAvatarPosition,
  saveAvatarImage, loadUserAvatar
} from './avatar.js';

// ============================================
// My Page Content (Coordinator)
// ============================================

export async function loadMyPageContent() {
  const user = getCurrentUser();
  if (!user) return;

  const feed = document.getElementById('myPageFeed');
  if (feed) {
    // Loading spinner (safe static HTML)
    feed.innerHTML = '<div class="loading-state"><div class="spinner"></div></div>';
  }

  const nickname = getUserNickname() || '닉네임 없음';
  const nicknameEl = document.getElementById('myPageNickname');
  if (nicknameEl) {
    nicknameEl.textContent = nickname;
  }

  const userIdEl = document.getElementById('myPageUserId');
  if (userIdEl) {
    const email = user.email || '';
    const userId = email.split('@')[0] || user.uid.substring(0, 8);
    userIdEl.textContent = `@${userId}`;
  }

  updateCarbonDisplay();

  await loadUserAvatar();
}

// ============================================
// Legacy Functions (Stubs)
// ============================================

export function switchMyPageTab() {
  // Legacy - no longer used
}

export async function loadMyProfilesList() {
  // Legacy - profiles managed via profile manager modal
}

// ============================================
// MyPage 객체 (하위 호환성)
// ============================================

export const MyPage = {
  // Carbon
  openCarbonModal,
  closeCarbonModal,
  updateCarbonDisplay,
  loadCarbonHistory,
  filterCarbonHistory,
  openCarbonRechargeModal,
  closeCarbonRechargeModal,
  selectCarbonPackage,
  purchaseCarbon,
  updateCarbonBalance,
  loadCarbonProducts,
  verifyGooglePurchase,
  verifyApplePurchase,
  // Content
  loadMyPageContent,
  // Legacy
  switchMyPageTab,
  loadMyProfilesList,
  // Avatar
  openAvatarUploadModal,
  closeAvatarUploadModal,
  handleAvatarFileSelect,
  updateAvatarPosition,
  saveAvatarImage,
  loadUserAvatar
};

// CarbonModule for retry button and IAP callbacks
export const CarbonModule = {
  loadCarbonProducts,
  verifyGooglePurchase,
  verifyApplePurchase
};

// ============================================
// window 노출 - 다른 모듈에서 호출 필요
// ============================================

// 마이페이지 콘텐츠 로딩 (navigation에서 호출)
window.loadMyPageContent = loadMyPageContent;
// 카본 디스플레이 (auth.js에서 호출)
window.updateCarbonDisplay = updateCarbonDisplay;
// 아바타 모달 (동적 생성된 HTML에서 호출)
window.closeAvatarUploadModal = closeAvatarUploadModal;
window.handleAvatarFileSelect = handleAvatarFileSelect;
window.updateAvatarPosition = updateAvatarPosition;
window.saveAvatarImage = saveAvatarImage;
// 카본 모듈 (동적 생성된 HTML에서 호출 - 재시도 버튼, IAP 콜백)
window.CarbonModule = CarbonModule;
